export default "__VITE_ASSET__D4bJVYvi__"